<script>
export default {
	name: 'LoadingIndicator',
	props: {
		text: {
			type: String,
			default: '',
		},
	},
}
</script>

<template>
	<div class="loading-indicator text-center py-3">
		<div class="spinner-border text-primary" role="status">
			<span class="sr-only">{{ text }}</span>
		</div>
		<p class="mt-2" v-if="text">{{ text }}</p>
	</div>
</template>

<style scoped>
.loading-indicator {
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
}
</style>

